import { useRef, useState } from 'react';

type UseScrollButtonsOptions = {
  scrollAmount: number;
};

export const useScrollButtons = ({ scrollAmount }: UseScrollButtonsOptions) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    if (scrollContainerRef.current) {
      const { clientWidth, scrollLeft, scrollWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        behavior: 'smooth',
        left: -scrollAmount,
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        behavior: 'smooth',
        left: scrollAmount,
      });
    }
  };

  return {
    canScrollLeft,
    canScrollRight,
    scrollContainerRef,
    scrollLeft,
    scrollRight,
    updateScrollButtons,
  };
};
